const PRIVACY_UNIVERSITY_TARGET_URL =
  'https://universidadedaprivacidade.com.br/'
const PRIVACY_UNIVERSITY_STORAGE_KEY_PREFIX =
  'privacy-university-banner-preferences'
const privacyUniversity = {
  PRIVACY_UNIVERSITY_TARGET_URL,
  PRIVACY_UNIVERSITY_STORAGE_KEY_PREFIX,
}

export default privacyUniversity
